import { gql } from '@apollo/client';

// Lightweight query to get the logged-in user's phone fields for gift card activation.
// Uses @apollo/client gql (not the codegen wrapper) so no schema regen needed.
export const GET_CURRENT_USER_PHONE = gql`
  query GetCurrentUserPhone {
    getCurrentUser {
      _id
      countryCode
      phoneNumber
    }
  }
`;

export const VALIDATE_GIFT_CARD = gql(`
  query ValidateGiftCardCodeForActivation($code: String!) {
    validateGiftCardCodeForActivation(code: $code) {
      result
      message
      packageSummary {
        giftCardId
        planId
        planName
        programId
        programName
        sessionCount
        amount
        originalPrice
        currency
      }
    }
  }
`);

// Uses plain @apollo/client gql (not codegen) to match the rest of this file.
// planId comes from packageSummary.planId returned by VALIDATE_GIFT_CARD.
export const VALIDATE_PROMOTION_CODE_FOR_GIFT = gql`
  query ValidatePromotionCodeForGiftCard($code: String!, $planId: ID!) {
    validatePromotionCode(code: $code, planId: $planId) {
      valid
      message
      discount {
        promotionCode
        percentOff
        originalAmount
        discountAmount
        finalAmount
      }
    }
  }
`;

export const PREVIEW_GIFT_CARD_REDEMPTION = gql(`
  query PreviewGiftCardRedemption($code: String!) {
    previewGiftCardRedemption(code: $code) {
      valid
      message
      currentBalance
      sessionsToAdd
      balanceAfterRedemption
      packageSummary {
        giftCardId
        planId
        planName
        programId
        programName
        sessionCount
        amount
        originalPrice
        currency
      }
    }
  }
`);
